import { useCallback } from 'react';
import { ScheduledBatchState } from 'ducks/scheduled-batch/slices';
import {
  createScheduledBatch,
  updateScheduledBatch,
  updateScheduledBatchParameters,
} from 'ducks/scheduled-batches/operators';
import { ProjectsScheduledBatchesCreatePayload } from 'ducks/types/payload-types';
import { ProjectParameters } from 'ducks/types/store-types';
import { useScrubParameters } from 'modals/batches/hooks/useScrubParameters';
import { offsetTimezoneLocal } from 'utils/dates';
import { createParameters } from 'utils/helpers';

export const useScheduleBatchSubmit = (
  project_id: number | null,
  scheduled_batch_id: number | null,
  is_active: boolean,
  batch_parameters: ProjectParameters,
) => {
  const { scrubParameters } = useScrubParameters();

  const submitScheduleBatch = useCallback(
    async (values: ScheduledBatchState) => {
      const data: ProjectsScheduledBatchesCreatePayload = {
        scheduled_batch_name: values.scheduled_batch_name,
        batch_definition_id: values.batch_definition_id,
        interval_id: values.interval_id,
        interval_frequency: values.interval_frequency,
        interval_bitmask: values.interval_bitmask && values.interval_id === 4 ? values.interval_bitmask : 0,
        start_datetime_utc: offsetTimezoneLocal(values.start_datetime_formatted, { local_timezone: true }),
        next_datetime_utc: offsetTimezoneLocal(values.next_datetime_formatted, { local_timezone: true }),
        finish_datetime_utc: offsetTimezoneLocal(values.finish_datetime_formatted, { local_timezone: true }),
        is_active,
        parameters: [],
      };

      if (scheduled_batch_id) {
        const scrubbed_parameters = scrubParameters(batch_parameters);
        await updateScheduledBatch(scheduled_batch_id, data);
        await updateScheduledBatchParameters(scheduled_batch_id, scrubbed_parameters);
      }

      if (!scheduled_batch_id) {
        data.parameters = createParameters(batch_parameters);
        if (project_id) {
          await createScheduledBatch(project_id, data);
        }
      }
    },
    [batch_parameters, is_active, project_id, scheduled_batch_id, scrubParameters],
  );
  return { submitScheduleBatch };
};
